import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit, isObject } from 'lodash';

export default class RetinaImage extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const nextImageSrc = isObject(nextProps.image) ? nextProps.image.src : nextProps.image;

        if (nextImageSrc !== prevState.image.src) {
            return {
                image: isObject(nextProps.image)
                    ? nextProps.image
                    : {
                        ...prevState.image,
                        src: nextImageSrc,
                    },
            };
        }

        return null;
    }

    static propTypes = {
        image: PropTypes.any.isRequired,
        role: PropTypes.string,
        imageRef: PropTypes.func,
        isSmall: PropTypes.bool,
    };

    static defaultProps = {
        role: 'presentation',
        imageRef: null,
        isSmall: false,
    };

    constructor(props) {
        super(props);

        this.state = { image: {} };
    }

    onImgLoad = ({ target: img }) => {
        if (!this.state.image.width) {
            this.setState({
                image: {
                    ...this.state.image,
                    width: img.width,
                    height: img.height,
                },
            });
        }
    };

    get dimensionProps() {
        const { image } = this.state;
        const { isSmall } = this.props;
        const divisor = isSmall ? 4 : 2;

        return {
            ...(image.width && {
                width: image.width / divisor,
                height: image.height / divisor,
            }),
        };
    }

    render() {
        const { imageRef } = this.props;
        const { image } = this.state;

        return (
            <img
                onLoad={this.onImgLoad}
                alt=""
                ref={imageRef}
                src={image.src}
                {...this.dimensionProps}
                {...omit(this.props, 'image', 'imageRef', 'isSmall')}
            />
        );
    }
}
